import { render, staticRenderFns } from "./FitModel.vue?vue&type=template&id=387cb8b1&scoped=true&"
import script from "./FitModel.vue?vue&type=script&lang=js&"
export * from "./FitModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387cb8b1",
  null
  
)

export default component.exports